module.exports = __webpack_public_path__ + "static/media/img01.c741738e.webp";